class ProductStickyAddToCart extends HTMLElement {
  constructor () {
    super()
    this.productBuyButtons = null
    this.footerGroup = null
    this.scrollTimeout = null
    this.overlayActive = false
    this.handleScroll = this.handleScroll.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.handleOverlayShow = this.handleOverlayShow.bind(this)
    this.handleOverlayHide = this.handleOverlayHide.bind(this)
  }

  connectedCallback () {
    this.init()
  }

  disconnectedCallback () {
    this.cleanup()
  }

  init () {
    this.productBuyButtons = document.querySelector('.product-buy-buttons')
    this.footerGroup = document.querySelector('.footer-group')
    if (!this.productBuyButtons || !this.footerGroup) {
      console.warn('Required sections not found for sticky add to cart')
      return
    }
    this.setupEventListeners()
    this.updateVisibility()
  }

  setupEventListeners () {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.handleResize, { passive: true })
    window.addEventListener('show:body-obscure', this.handleOverlayShow)
    window.addEventListener('hide:body-obscure', this.handleOverlayHide)
    window.addEventListener('show:page-obscure', this.handleOverlayShow)
    window.addEventListener('hide:page-obscure', this.handleOverlayHide)
  }

  handleScroll () {
    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = setTimeout(() => {
      this.updateVisibility()
    }, 16)
  }

  handleResize () {
    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = setTimeout(() => {
      this.updateVisibility()
    }, 100)
  }

  handleOverlayShow () {
    this.overlayActive = true
    this.classList.remove('product-sticky-add-to-cart--show')
  }

  handleOverlayHide () {
    this.overlayActive = false
    requestAnimationFrame(() => {
      this.updateVisibility()
    })
  }

  updateVisibility () {
    if (this.overlayActive) {
      this.classList.remove('product-sticky-add-to-cart--show')
      return
    }
    const buyButtonsRect = this.productBuyButtons.getBoundingClientRect()
    const footerRect = this.footerGroup.getBoundingClientRect()
    const windowHeight = window.innerHeight
    const buyButtonsAboveFold = buyButtonsRect.bottom <= 0
    const footerInViewport = footerRect.top < windowHeight && footerRect.bottom > 0
    const shouldShow = buyButtonsAboveFold && !footerInViewport
    if (shouldShow) {
      this.classList.add('product-sticky-add-to-cart--show')
    } else {
      this.classList.remove('product-sticky-add-to-cart--show')
    }
  }

  cleanup () {
    clearTimeout(this.scrollTimeout)
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('show:body-obscure', this.handleOverlayShow)
    window.removeEventListener('hide:body-obscure', this.handleOverlayHide)
    window.removeEventListener('show:page-obscure', this.handleOverlayShow)
    window.removeEventListener('hide:page-obscure', this.handleOverlayHide)
  }

  reinitialize () {
    this.cleanup()
    this.init()
  }
}
if (!customElements.get('product-sticky-add-to-cart')) {
  customElements.define('product-sticky-add-to-cart', ProductStickyAddToCart)
}
document.addEventListener('DOMContentLoaded', () => {
  const stickySection = document.querySelector('product-sticky-add-to-cart')
  if (stickySection) {
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const stickyElement = document.querySelector('product-sticky-add-to-cart')
          if (stickyElement && stickyElement.reinitialize) {
            stickyElement.reinitialize()
          }
        }
      })
    })
    mutationObserver.observe(stickySection, {
      childList: true,
      subtree: true,
    })
  }
})
